import Button from '../../../Shared/Form/Button'
import { Trans, useTranslation } from 'react-i18next'
import React, { memo, useEffect, useState } from 'react'
import MainHotel from '../../../Shared/Hotel/mainHotel'
import Loader from '../../../Shared/Loader'
import Pill from '../../../Shared/Pill'
import { constants } from '../../../../constants'
import Alert from '../../../Shared/Alert'
import ProLabel from '../../../Shared/ProLabel'
import Score from '../../../Shared/Score'
import { getRanking } from '../../../../http/driveApiGateway/client'

const CompareDetail = ({
                         item,
                         relatedItems,
                         compare,
                         onRemoveCompare,
                         onShowSearchView
                       }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [ranking, setRanking] = useState()
  const { t } = useTranslation()

  useEffect(() => {
    const compareIds = [].concat([item.id], compare)
    const fetchData = async () => {
      setLoading(true)
      setError(false)
      try {
        const response = await getRanking(compareIds).fetchPromise
        setRanking(response)
      } catch (error) {
        console.error(error)
        setError(true)
      } finally {
        setLoading(false)
      }
    }
    fetchData().catch(console.error)
  }, [item, compare])

  if (error) {
    return <Alert type={'danger'}>{t('DEFAULT_ERROR_MESSAGE')}</Alert>
  }
  return (
    <React.Fragment>
      <MainHotel item={item} relatedItems={relatedItems}/>
      <div className="container container-detail page-compare-hotel">
        {loading && <Loader size={64}/>}
        {ranking &&
          <>
            <br/><br/>
            <Button align="right" onClick={onShowSearchView}>
              <Trans>BUTTON_ADD_HOTEL</Trans>
            </Button>
            {
              compare.length > 0 && <div className="compare-pills">
                <span>{t('compareHotels.comparisonPills.prefixLabel')}</span>
                {[].concat([item.id], compare).map((hotelId) => {
                  const hotel = ranking.hotels.find((h) => h.hotelId === hotelId)
                  const isActiveHotel = hotelId === item.id
                  if (isActiveHotel) {
                    return null
                  }
                  return (
                    <Pill
                      key={hotelId}
                      onRemove={isActiveHotel ? null : () => onRemoveCompare(hotelId)}
                      text={hotel && hotel.name}
                    />
                  )
                })}
              </div>
            }
            {constants.scores.seq.map((scoreId) => {
              const rankingScores = ranking.scores[scoreId]
              return (
                <div className="Ranking clearfix" key={scoreId}>

                  <h3><Trans>{constants.scores.types[scoreId].name}</Trans></h3>
                  {constants.scores.types[scoreId].pro &&
                    <ProLabel/>
                  }
                  <div className="RankingScores">
                    <span className="RankingScores-Name"><strong><Trans>LABEL_HOTEL</Trans></strong></span>
                    <strong><Trans>LABEL_RANKING_SCORE</Trans></strong>
                  </div>
                  {rankingScores.items.map((score, id) => {
                    return (
                      <div key={id}
                           className={'RankingScores ' + (score.hotelId === item.id ? 'RankingScores-Active' : '')}>
                        <span className="RankingScores-Name">{score.name}</span>
                        <Score key={id} percentage={score.percentage} id={scoreId}
                               label={Math.round(score.percentage * 100) + '%'} type="large"/>
                      </div>
                    )
                  })}
                  <br/><br/>
                </div>
              )
            })};
          </>
        }
      </div>
    </React.Fragment>
  )
}

export default memo(CompareDetail)
